<div class="dropdown-container">
  <div
    class="dropdown subheading-01-semi-bold"
    [style.height.px]="config.size"
    (click)="open()"
    [class.disabled]="isDisabled"
    [class.error]="hasError"
    matRipple
  >
    <span class="text" *ngIf="selected == undefined || selected.length == 0">{{
      config.placeholder
    }}</span>
    <img
      class="option-image"
      *ngIf="getOptionImage(selected) as image"
      [src]="image"
      alt=""
    />
    <span class="text" *ngIf="selected != undefined">{{ selected }}</span>
    <qr-icon
      class="arrow-drop-down"
      [name]="ARROW_DROP_DOWN"
      [color]="getArrowColor()"
    ></qr-icon>
  </div>

  <mat-select
    class="dropdown-select"
    #matSelect
    [style.height.px]="config.size"
    [(ngModel)]="selected"
    (selectionChange)="selectChange()"
    [multiple]="config.isMultiple"
    (openedChange)="openedChange($event)"
    (closed)="blurChange.emit(true)"
  >
    <mat-option *ngFor="let option of config.options" [value]="option">
      <img
        class="option-image option-image--list"
        *ngIf="getOptionImage(option) as image"
        [src]="image"
        alt=""
      />{{ option }}
    </mat-option>
    <div *ngIf="config.buttonEnd" id="button-container">
      <qr-button
        [config]="button32pxHierarchy1"
        (click)="buttonClick()"
      ></qr-button>
    </div>
  </mat-select>
</div>
